<template>
  <router-link v-if="data" :to="link"
    class="card card-compare"
    :class="{ 'small': small }"
    :title="`Compare ${product1.name} with ${product2.name}`">
    <div class="compare-heading">
      <div class="compare-img">
        <img v-lazy="product1.image"
          :alt="product1.name"
          :title="product1.name"
          loading="lazy">
      </div>
      <span class="versus">vs</span>
      <div class="compare-img">
        <img v-lazy="product2.image"
          :alt="product2.name"
          :title="product2.name"
          loading="lazy">
      </div>
    </div>

    <div class="compare-content">
      <template v-if="small">
        <div>{{ product1.name }} VS {{ product2.name }}</div>
      </template>

      <template v-else>
        <span>{{ product1.name }}</span>
        <span class="versus">VS</span>
        <span>{{ product2.name }}</span>
      </template>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'CardCompare',

  props: {
    data: {
      type: Object,
      required: false,
      default: () => {},
    },

    small: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    link() {
      const path = '/compare';
      const query = `?product1=${this.product1.slug}&product2=${this.product2.slug}`;
      return `${path}${query}`;
    },

    product1() {
      if (!this.data.product_1) {
        return {
          name: null,
          slug: null,
          image: '/img/pilihlaptop-logo.min.png',
        };
      }

      const { name, slug, cover } = this.data.product_1;
      return {
        name,
        slug,
        image: this.getImageUrl(cover),
      };
    },

    product2() {
      if (!this.data.product_2) {
        return {
          name: null,
          slug: null,
          image: '/img/pilihlaptop-logo.min.png',
        };
      }

      const { name, slug, cover } = this.data.product_2;
      return {
        name,
        slug,
        image: this.getImageUrl(cover),
      };
    },
  },

  methods: {
    getImageUrl(image, size) {
      const imageSize = size || 'medium';
      return `${process.env.VUE_APP_IMAGE_PATH}thumbnail/${imageSize}/${image}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  .card-compare {
    margin-bottom: 1rem;
    border-radius: 0.5rem;
    overflow: hidden;

    .compare-heading {
      position: relative;
      display: flex;
      align-items: center;
      justify-items: space-between;

      .compare-img {
        width: 50%;
        height: 9.75rem;

        @include media ("<=tablet") {
          height: 8rem;
        }

        &:first-child {
          border-right: 1px solid $grey-fade;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .versus {
        position: absolute;
        left: 50%;
        top: 50%;
        display: inline-block;
        height: 2rem;
        width: 2rem;
        background-color: #bfd50c;
        transform: translate3d(-50%, -50%, 0);
        border-radius: 1.5rem;
        font-weight: 700;
        font-style: italic;
        line-height: 2rem;
        text-align: center;
        color: white;
        z-index: 2;
      }
    }

    .compare-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: $grey-fade;
      font-size: 0.875rem;
      color: black;

      span {
        padding: 0.75rem 1rem;
        width: 100%;
        font-weight: 500;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;

        @include media ("<=tablet") {
          padding: 0.5rem 0.75rem;
          font-size: 0.75rem;
        }

        &.versus {
          display: none;
        }

        &:first-child {
          border-right: 1px solid #dadada;
        }
      }
    }

    &.small {
      &:hover {
        .compare-content div {
          transform: translateX(calc(300px - 100%));
        }
      }

      @include media ("<=tablet") {
        margin-bottom: 0.75rem;
      }

      .compare-heading {
        .compare-img {
          height: 7rem;

          @include media ("<=tablet") {
            height: 5rem;
          }
        }

        .versus {
          @include media ("<=tablet") {
            height: 1.5rem;
            width: 1.5rem;
            line-height: 1.5rem;
            z-index: 2;
          }
        }
      }

      .compare-content {
        position: relative;
        height: 2.125rem;
        overflow: hidden;

        &::after {
          content: '';
          position: absolute;
          right: 0;
          top: 0;
          height: 2.125rem;
          width: 2rem;
          background-color: $grey-fade;
          background: linear-gradient(to right,  rgba($grey-fade, 0) 0%,rgba($grey-fade, 1) 80%);
          z-index: 2;
        }

        div {
          position: absolute;
          display: block;
          padding: 0.5rem 1rem;
          overflow: hidden;
          font-size: 0.75rem;
          font-weight: normal;
          // text-overflow: ellipsis;
          white-space: nowrap;
          transform: translateX(0);
          transition: 5s;

          @include media ("<=tablet") {
            padding: 0.375rem 0.75rem;
            font-size: 0.675rem;
          }
        }
      }
    }
  }
</style>
